import React from 'react';
import get from 'lodash/get';
import BaseCell from './BaseCell';

const formatCellValue = (value, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  const options = {
    minimumFractionDigits,
    maximumFractionDigits,
  };
  if (value) {
    return `$${value.toLocaleString('en', options)}`;
  }
  return '$0.00';
};

const PriceCell = ({ dataItem, field, ...props }) => (
  <BaseCell {...props}>
    {formatCellValue(get(dataItem, field), props.minimumFractionDigits, props.maximumFractionDigits)}
  </BaseCell>
);

export default PriceCell;
